
import {
    Box, Select, Button, FormLabel, Input, RadioGroup, Radio,Tabs,Tab,TabList,TabPanel,TabPanels,
    NumberInput, NumberInputField, Checkbox, Stack, Switch, SimpleGrid, Text, SkeletonText
} from "@chakra-ui/react"
import { MdFilterAlt, MdCancel, MdClear } from "react-icons/md"
import { useState, useEffect } from "react";
import LokacijeSelect from "../lokacija/LokacijeSelect";
import PosjednikKnjigaSelect from "../osoba/PosjednikKnjigaSelect";
import KnjigeSelect from "../knjiga/KnjigeSelect";
import { getPosjednikeNove, getPosjednikePrijasnje } from "../../util/apiOsoba";
import { getPasmineKlijenta } from "../../util/apiPasmina";
import { getKnjigeShort } from "../../util/apiKnjiga";
import SmallMultiFilter from "../custom/SmallMultiFilter";
import MigracijaList from "./MigracijaList";

export const RegistarFilterTypes = {
    Knjige: { sif: "knjige", naslov: "Knjige", size: "sm" },
    StanjeNaDan: { sif: "stnd", naslov: "Stanje goveda na dan", size: "sm" },
    OtislaSGospodarstva: { sif: "otgspd", naslov: "Otišla s gospodarstva", size: "sm" },
    DolasciTipPeriod: { sif: "doltipper", naslov: "Dolasci po tipu i periodu", size: "3xl" },
    OdlasciTipPeriod: { sif: "odltipper", naslov: "Odlasci po tipu i periodu", size: "3xl" },
    Lokacije: { sif: "lokac", naslov: "Pregled po lokacijama", size: "sm" },
    TovDani: { sif: "tov", naslov: "Dani tova", size: "sm" },
    TovDatumi: { sif: "tovdat", naslov: "Datum stavljanja u tov", size: "sm" },
    RodDatumi: { sif: "roddat", naslov: "Datum rođenja", size: "sm" },
    BrzaPretraga: { sif: "brzpret", naslov: "Postavke brze pretrage", size: "sm" },
    Posjednici: { sif: "posjednici", naslov: "Posjednici", size: "sm" },
    Spol: { sif: "spol", naslov: "Spol", size: "sm" },
    Pasmine: { sif: "pasm", naslov: "Pasmine", size: "sm" },
    BezFiltera: { sif: "bfl", naslov: "-----" }
}


export default function RegistarFilter({ onSetFilter, onClose, onClear, registerfiltertype, selectedKnjige, selectedPosjednici = [], filterValue = null, lokacije, selectedQuickFilterTypes = "zivbr" }) {
    const [knjige, setKnjige] = useState(selectedKnjige);
    const [state, setState] = useState();
    const [quickFilterTypesState, setQuickFilterTypesState] = useState(selectedQuickFilterTypes)
    const [stateDolTipPer, setStateDolTipPer] = useState({ filterbymigracije:true,tip: "DOL", datod: new Date().toISOString().split("T")[0], datdo: new Date().toISOString().split("T")[0], dkup: true, duvoz: true, dtelj: true, posjednik_knjiga:"k",prijasnji_posjednik_knjiga: -1, prijasnji_posjednik_knjiga_naziv: "",migracijeid:[] });
    const [stateOdlTipPer, setStateOdlTipPer] = useState({ filterbymigracije:true,tip: "ODL", datod: new Date().toISOString().split("T")[0], datdo: new Date().toISOString().split("T")[0], oprod: true, omik: true, okla: true, oizvz: true, oizgb: true, ougin: true, posjednik_knjiga:"k",novi_posjednik_knjiga: -1, novi_posjednik_knjiga_naziv: "",migracijeid:[] });
    const [selectedposjednici, setSelectedPosjednici] = useState([]);
    const [posjednici, setPosjednici] = useState([]);
    const [pasmine, setPasmine] = useState([]);
    const [err,setErr]=useState("");
    useEffect(() => {
        const PrepareData = async () => {
            if (registerfiltertype.sif === RegistarFilterTypes.DolasciTipPeriod.sif) {
                try {
                    const res = await getPosjednikePrijasnje();
                    if (res.status === 200) {
                        setPosjednici(res.res);
                    }
                    const resKnjige=await getKnjigeShort();
                    if (resKnjige.status===200) {
                        setKnjige(resKnjige.res);
                    }
                } catch (error) {
                    setStateDolTipPer({ ...stateDolTipPer,posjednik_knjiga:"k", prijasnji_posjednik_knj1: -1, prijasnji_posjednik_knjiga_naziv: "" })
                }
            }
            if (registerfiltertype.sif === RegistarFilterTypes.OdlasciTipPeriod.sif) {
                try {
                    const res = await getPosjednikeNove();
                    if (res.status === 200) {
                        setPosjednici(res.res);
                    }
                    const resKnjige=await getKnjigeShort();
                    if (resKnjige.status===200) {
                        setKnjige(resKnjige.res);
                    }
                } catch (error) {
                    setStateOdlTipPer({ ...stateOdlTipPer, novi_posjednik_knjiga: -1, novi_posjednik_knjiga_naziv: "" })
                }
            }
            if (registerfiltertype.sif === RegistarFilterTypes.Pasmine.sif) {
                try {
                    const res = await getPasmineKlijenta();
                    if (res.status === 200) {
                        const _pasmine = res.res.map((item) => { return { ...item, selected: false } }).sort((a, b) => a.pasmina < b.pasmina ? -1 : 1);
                        if (Array.isArray(filterValue)) {
                            for (let index = 0; index < filterValue.length; index++) {
                                const _ix = _pasmine.findIndex((item) => item.sifra === filterValue[index]);
                                if (_ix !== -1) {
                                    _pasmine[_ix].selected = true;
                                }

                            }
                        }


                        setPasmine(_pasmine);//****TU SI STAO */
                    }
                } catch (error) {
                    setPasmine([]);
                }
            }
            if (registerfiltertype.sif === RegistarFilterTypes.StanjeNaDan.sif) {
                if (filterValue === null) {
                    setState(new Date().toISOString().split("T")[0]);
                } else {
                    setState(filterValue);
                }
            }
            if (registerfiltertype.sif === RegistarFilterTypes.Spol.sif) {
                setState(filterValue);
            }
            if (registerfiltertype.sif === RegistarFilterTypes.TovDani.sif) {
                if (filterValue === null) {
                    setState({ tip: "TOV", min: 0, max: 160 });
                } else {
                    setState({ tip: "TOV", min: filterValue.min, max: filterValue.max });
                }

            }
            if (registerfiltertype.sif === RegistarFilterTypes.TovDatumi.sif) {
                if (filterValue === null) {
                    let _datdo = new Date();
                    let _datod = new Date(new Date().setDate(_datdo.getDate() - 150));

                    setState({ tip: "TOV_DAT", datod: _datod.toISOString().split("T")[0], datdo: _datdo.toISOString().split("T")[0] });
                } else {
                    setState({ tip: "TOV_DAT", datod: filterValue.datod, datdo: filterValue.datdo });
                }

            }
            if (registerfiltertype.sif === RegistarFilterTypes.RodDatumi.sif) {
                if (filterValue === null) {
                    let _datdo = new Date();
                    let _datod = new Date(new Date().setDate(_datdo.getDate() - 150));

                    setState({ tip: "ROD_DAT", datod: _datod.toISOString().split("T")[0], datdo: _datdo.toISOString().split("T")[0] });
                } else {
                    setState({ tip: "ROD_DAT", datod: filterValue.datod, datdo: filterValue.datdo });
                }

            }
            if (registerfiltertype.sif === RegistarFilterTypes.BrzaPretraga.sif) {
                setState(selectedQuickFilterTypes)
            }
            if (registerfiltertype.sif === RegistarFilterTypes.DolasciTipPeriod.sif) {
                if (filterValue !== null) {
                    setStateDolTipPer({ ...stateDolTipPer, datod: filterValue.datod, datdo: filterValue.datdo, dkup: filterValue.dkup, duvoz: filterValue.duvoz, dtelj: filterValue.dtelj, posjednik_knjiga:filterValue.posjednik_knjiga ,prijasnji_posjednik_knjiga: filterValue.prijasnji_posjednik_knjiga, prijasnji_posjednik_knjiga_naziv: filterValue.prijasnji_posjednik_knjiga_naziv,migracijeid:filterValue.migracijeid });
                }
            }
            if (registerfiltertype.sif === RegistarFilterTypes.OdlasciTipPeriod.sif) {
                if (filterValue !== null) {
                    setStateOdlTipPer({ ...stateOdlTipPer, datod: filterValue.datod, datdo: filterValue.datdo, oizgb: filterValue.oizgb, oizvz: filterValue.oizvz, okla: filterValue.okla, omik: filterValue.omik, oprod: filterValue.oprod, ougin: filterValue.ougin, posjednik_knjiga:filterValue.posjednik_knjiga ,novi_posjednik_knjiga: filterValue.novi_posjednik_knjiga, novi_posjednik_knjiga_naziv: filterValue.novi_posjednik_knjiga_naziv,migracijeid:filterValue.migracijeid });

                }
            }


        }

        PrepareData();

    }, [registerfiltertype.sif])

    const ValidateData=()=>{
        let _resPoruka="";
        if (registerfiltertype.sif===RegistarFilterTypes.DolasciTipPeriod.sif) {
            if (stateDolTipPer.filterbymigracije) {
              if (stateDolTipPer.migracijeid.length===0) {
                _resPoruka="Nije odabrana niti jedna migracija!"
              }  
            } else {
                if (isNaN(new Date(stateDolTipPer.datod)) || isNaN(new Date(stateDolTipPer.datdo))) {
                    _resPoruka="Nije unesen datum od i/ili datum do!"
                }
            }
        }
        //
        if (registerfiltertype.sif===RegistarFilterTypes.OdlasciTipPeriod.sif) {
            if (stateOdlTipPer.filterbymigracije) {
              if (stateOdlTipPer.migracijeid.length===0) {
                _resPoruka="Nije odabrana niti jedna migracija!"
              }  
            } else {
                if (isNaN(new Date(stateOdlTipPer.datod)) || isNaN(new Date(stateOdlTipPer.datdo))) {
                    _resPoruka="Nije unesen datum od i/ili datum do!"
                }
            }
        }
        return _resPoruka;
    }
    const filterData = () => {
        const _poruka=ValidateData();
        if (_poruka==="") {
            
        
        if (registerfiltertype.sif === RegistarFilterTypes.Knjige.sif) {
            onSetFilter(knjige);
        } else if (registerfiltertype.sif === RegistarFilterTypes.StanjeNaDan.sif || registerfiltertype.sif === RegistarFilterTypes.Spol.sif) {
            onSetFilter(state);
        } else if (registerfiltertype.sif === RegistarFilterTypes.DolasciTipPeriod.sif) {
            //onSetFilter(stateDolTipPer);
            const _r={...stateDolTipPer};
            if (stateDolTipPer.filterbymigracije===false) {
                _r.migracijeid=[];
            }
            onSetFilter(_r);
        } else if (registerfiltertype.sif === RegistarFilterTypes.OdlasciTipPeriod.sif) {
            const _r={...stateOdlTipPer};
            if (stateOdlTipPer.filterbymigracije===false) {
                _r.migracijeid=[];
            }
            onSetFilter(_r);
        } else if (registerfiltertype.sif === RegistarFilterTypes.Lokacije.sif) {
            onSetFilter(state);
        } else if (registerfiltertype.sif === RegistarFilterTypes.TovDani.sif) {
            onSetFilter(state);
        } else if (registerfiltertype.sif === RegistarFilterTypes.TovDatumi.sif) {
            onSetFilter(state);
        } else if (registerfiltertype.sif === RegistarFilterTypes.RodDatumi.sif) {
            onSetFilter(state);
        } else if (registerfiltertype.sif === RegistarFilterTypes.BrzaPretraga.sif) {
            onSetFilter(quickFilterTypesState);
        } else if (registerfiltertype.sif === RegistarFilterTypes.Posjednici.sif) {
            onSetFilter(selectedposjednici);
        } else if (registerfiltertype.sif === RegistarFilterTypes.Pasmine.sif) {
            onSetFilter(pasmine.filter((item) => item.selected === true).map((item) => item.sifra))
        }
    } else {
        setErr(_poruka);
    }
        //onClose();
    }
    const DatumChanged = (event) => {
        if (registerfiltertype.sif === RegistarFilterTypes.DolasciTipPeriod.sif) {
            if (event.target.id === "idDolDatOd") {
                setStateDolTipPer({ ...stateDolTipPer, datod: event.target.value });
            } else {
                setStateDolTipPer({ ...stateDolTipPer, datdo: event.target.value });
            }
        }
        //
        if (registerfiltertype.sif === RegistarFilterTypes.OdlasciTipPeriod.sif) {
            if (event.target.id === "idOdlDatOd") {
                setStateOdlTipPer({ ...stateOdlTipPer, datod: event.target.value });
            } else {
                setStateOdlTipPer({ ...stateOdlTipPer, datdo: event.target.value });
            }
        }

    }
    const setFilterValue = (event) => {
        if (registerfiltertype.sif === RegistarFilterTypes.StanjeNaDan.sif) {
            setState(event.target.value);
        }
    }


    const getPosjednikNaziv = (id) => {
        const _id = Number(id);
        if (_id === -1) {
            return "";
        } else {
            return posjednici.filter((item) => item.id === _id)[0].naziv;
        }
    }

    const getKnjigaNaziv=(id)=>{
        const _id = Number(id);
        if (_id === -1) {
            return "";
        } else {
            return knjige.filter((item) => item.id === _id)[0].naziv;
        }
    }

    const DolazakTipPeriodTabs=()=>{
        if (registerfiltertype.sif === RegistarFilterTypes.DolasciTipPeriod.sif) {
            if (posjednici.length > 0 && knjige.length>0) {
                return (
                <Box>
                    <Tabs variant={'enclosed'} colorScheme="grunt2" size={'sm'}>
                        <TabList>
                            <Tab onClick={()=>setStateDolTipPer({...stateDolTipPer,filterbymigracije:true})}>Odabir migracije</Tab>
                            <Tab onClick={()=>setStateDolTipPer({...stateDolTipPer,filterbymigracije:false})}>Pretraga po parametrima</Tab>
                        </TabList>
                        <TabPanels>
                            <TabPanel>
                                 <MigracijaList vrsta="d" preselectedMigracijeId={stateDolTipPer.migracijeid} onSelectChange={(ar)=>setStateDolTipPer({...stateDolTipPer,migracijeid:ar})}/>
                            </TabPanel>
                            <TabPanel>
                                <Box>
                                    <FormLabel>Tip dolazne migracije</FormLabel>
                                    <Stack spacing={[15]} direction={['column', 'row']} mb={'0.5rem'}>
                                        <Checkbox colorScheme={'grunt2'} id="cbDkup" defaultChecked value={'DKUP'} isChecked={stateDolTipPer.dkup} onChange={(e) => { setStateDolTipPer({ ...stateDolTipPer, dkup: e.target.checked }) }} size={'sm'}>Kupnja</Checkbox>
                                        <Checkbox colorScheme={'grunt2'} id="cbDuvoz" defaultChecked value={'DUVOZ'} isChecked={stateDolTipPer.duvoz} onChange={(e) => { setStateDolTipPer({ ...stateDolTipPer, duvoz: e.target.checked }) }} size={'sm'}>Uvoz</Checkbox>
                                        <Checkbox colorScheme={'grunt2'} id="cbDtelj" defaultChecked value={'DTELJ'} isChecked={stateDolTipPer.dtelj} onChange={(e) => { setStateDolTipPer({ ...stateDolTipPer, dtelj: e.target.checked }) }} size={'sm'}>Teljenje</Checkbox>
                                    </Stack>
                                    <FormLabel mt={'1rem'} size={'xs'}>Od datuma</FormLabel>
                                    <Input focusBorderColor='grunt2.400' id="idDolDatOd" size="xs" type="date" value={stateDolTipPer.datod} onChange={DatumChanged} variant={'filled'} />
                                    <FormLabel mt={'1rem'} size={'xs'}>Do datuma</FormLabel>
                                    <Input focusBorderColor='grunt2.400' id="idDolDatDo" size="xs" type="date" value={stateDolTipPer.datdo} onChange={DatumChanged} variant={'filled'} placeholder="dd.MM.YYYY" />
                                    <RadioGroup mb={'1rem'} variant={'filled'} color={'grunt2'} value={stateDolTipPer.posjednik_knjiga}
                                        size={'sm'} fontSize={'xs'} colorScheme='grunt2' mt={'1rem'}>
                                        <Stack direction={'row'} > 
                                            <Radio id={'rKnj'} value="k" onChange={() => setStateDolTipPer({...stateDolTipPer,posjednik_knjiga:"k",prijasnji_posjednik_knjiga:-1,prijasnji_posjednik_knjiga_naziv:""})}>Knjiga</Radio>
                                            <Radio id={'rPos'} value="p" onChange={() => setStateDolTipPer({...stateDolTipPer,posjednik_knjiga:"p",prijasnji_posjednik_knjiga:-1,prijasnji_posjednik_knjiga_naziv:""})}>Posjednik</Radio>
                                        </Stack> 
                                    </RadioGroup>
                                    <FormLabel mt={'1rem'} size={'xs'}>{stateDolTipPer.posjednik_knjiga==="k"?"Knjiga":"Posjednik"}</FormLabel>
                                    
                                    <Select variant={'filled'} focusBorderColor='grunt2.400' disabled={posjednici.length === 0 || knjige.length===0} size={'xs'} value={stateDolTipPer.prijasnji_posjednik_knjiga} onChange={(event) => setStateDolTipPer({ ...stateDolTipPer, prijasnji_posjednik_knjiga: event.target.value, prijasnji_posjednik_knjiga_naziv: stateDolTipPer.posjednik_knjiga==="p"? getPosjednikNaziv(event.target.value):getKnjigaNaziv(event.target.value) })}>
                                        <option key='k0' value={"-1"}>--</option>
                                        {stateDolTipPer.posjednik_knjiga==="p"?
                                            posjednici.sort((a, b) => a.naziv < b.naziv ? -1 : 1).map((item, index) => {
                                                return (
                                                    <option key={`pos${item.id}`} value={item.id}>{item.naziv}</option>
                                                )
                                            }) :
                                            knjige.sort((a, b) => a.naziv < b.naziv ? -1 : 1).map((item, index) => {
                                                return (
                                                    <option key={`pos${item.id}`} value={item.id}>{item.naziv}</option>
                                                )
                                            })

                                        }

                                    </Select> 
                                </Box>
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </Box>
                )
            } else {
                return (
                    <Box>
                        <SkeletonText noOfLines={10} />
                    </Box>
                )
            }
        }
    }

    const OdlazakTipPeriodTabs=()=>{
        if (registerfiltertype.sif === RegistarFilterTypes.OdlasciTipPeriod.sif) {
            if (posjednici.length > 0 && knjige.length>0) {
                return (
                    <Box>
                        <Tabs variant={'enclosed'} colorScheme="grunt2" size={'sm'}>
                            <TabList>
                                <Tab onClick={()=>setStateOdlTipPer({...stateOdlTipPer,filterbymigracije:true})}>Odabir migracije</Tab>
                                <Tab onClick={()=>setStateOdlTipPer({...stateOdlTipPer,filterbymigracije:false})}>Pretraga po parametrima</Tab>
                            </TabList>
                            <TabPanels>
                                <TabPanel>
                                    <MigracijaList vrsta="o" preselectedMigracijeId={stateOdlTipPer.migracijeid} onSelectChange={(ar)=>setStateOdlTipPer({...stateOdlTipPer,migracijeid:ar})}/>
                                </TabPanel>
                                <TabPanel>
                                    <FormLabel>Tip dolazne migracije</FormLabel>
                                    {/* <CheckboxGroup colorScheme='grunt2'> */}
                                    <Stack direction={'row'}>
                                        <Stack spacing={[1]} direction={'column'} mb={'0.5rem'}>
                                            <Checkbox size={'sm'} colorScheme={'grunt2'} value={'OPROD'} isChecked={stateOdlTipPer.oprod} onChange={(e) => { setStateOdlTipPer({ ...stateOdlTipPer, oprod: e.target.checked }) }}>Prodaja</Checkbox>
                                            <Checkbox size={'sm'} colorScheme={'grunt2'} value={'OMIK'} isChecked={stateOdlTipPer.omik} onChange={(e) => { setStateOdlTipPer({ ...stateOdlTipPer, omik: e.target.checked }) }}>Interna migracija</Checkbox>
                                            <Checkbox size={'sm'} colorScheme={'grunt2'} value={'OKLA'} isChecked={stateOdlTipPer.okla} onChange={(e) => { setStateOdlTipPer({ ...stateOdlTipPer, okla: e.target.checked }) }}>Klaonica</Checkbox>
                                        </Stack>
                                        <Stack spacing={[1]} direction={'column'} mb={'0.5rem'}>
                                            <Checkbox size={'sm'} colorScheme={'grunt2'} value={'OIZVZ'} isChecked={stateOdlTipPer.oizvz} onChange={(e) => { setStateOdlTipPer({ ...stateOdlTipPer, oizvz: e.target.checked }) }}>Izvoz</Checkbox>
                                            <Checkbox size={'sm'} colorScheme={'grunt2'} value={'OIZGB'} isChecked={stateOdlTipPer.oizgb} onChange={(e) => { setStateOdlTipPer({ ...stateOdlTipPer, oizgb: e.target.checked }) }}>Krađa/izgubljeno</Checkbox>
                                            <Checkbox size={'sm'} colorScheme={'grunt2'} value={'OUGIN'} isChecked={stateOdlTipPer.ougin} onChange={(e) => { setStateOdlTipPer({ ...stateOdlTipPer, ougin: e.target.checked }) }}>Uginulo</Checkbox>
                                        </Stack>
                                    </Stack>
                                    {/* </CheckboxGroup> */}
                                    <FormLabel mt={'1rem'} size={'xs'}>Od datuma</FormLabel>
                                    <Input focusBorderColor='grunt2.400' id="idOdlDatOd" size="xs" type="date" value={stateOdlTipPer.datod} onChange={DatumChanged} variant={'filled'} />
                                    <FormLabel mt={'1rem'} size={'xs'}>Do datuma</FormLabel>
                                    <Input focusBorderColor='grunt2.400' id="idOdlDatDo" size={'xs'} type="date" value={stateOdlTipPer.datdo} onChange={DatumChanged} variant={'filled'} placeholder="dd.MM.YYYY" />
                                    <RadioGroup mb={'1rem'} variant={'filled'} color={'grunt2'} value={stateOdlTipPer.posjednik_knjiga}
                                        size={'sm'} fontSize={'xs'} colorScheme='grunt2' mt={'1rem'}>
                                        <Stack direction={'row'} > 
                                            <Radio id={'rKnj'} value="k" onChange={() => setStateOdlTipPer({...stateOdlTipPer,posjednik_knjiga:"k",novi_posjednik_knjiga_posjednik_knjiga:-1,novi_posjednik_knjiga_naziv:""})}>Knjiga</Radio>
                                            <Radio id={'rPos'} value="p" onChange={() => setStateOdlTipPer({...stateOdlTipPer,posjednik_knjiga:"p",novi_posjednik_knjiga_posjednik_knjiga:-1,novi_posjednik_knjiga_naziv:""})}>Posjednik</Radio>
                                        </Stack> 
                                    </RadioGroup>
                                    <FormLabel mt={'1rem'} size={'xs'}>{stateOdlTipPer.posjednik_knjiga==="k"?"Knjiga":"Posjednik"}</FormLabel>
                                    <Select variant={'filled'} focusBorderColor='grunt2.400' disabled={posjednici.length === 0 || knjige.length===0} size={'xs'} value={stateOdlTipPer.novi_posjednik_knjiga} onChange={(event) => setStateOdlTipPer({ ...stateOdlTipPer, novi_posjednik_knjiga: event.target.value, novi_posjednik_knjiga_naziv: stateOdlTipPer.posjednik_knjiga==="p"? getPosjednikNaziv(event.target.value):getKnjigaNaziv(event.target.value) })}>
                                        <option key='k0' value={"-1"}>--</option>
                                        {stateOdlTipPer.posjednik_knjiga==="p"?
                                            posjednici.sort((a, b) => a.naziv < b.naziv ? -1 : 1).map((item, index) => {
                                                return (
                                                    <option key={`pos${item.id}`} value={item.id}>{item.naziv}</option>
                                                )
                                            }) :
                                            knjige.sort((a, b) => a.naziv < b.naziv ? -1 : 1).map((item, index) => {
                                                return (
                                                    <option key={`pos${item.id}`} value={item.id}>{item.naziv}</option>
                                                )
                                            })

                                        }
                                    </Select>
                                </TabPanel>
                            </TabPanels>

                        </Tabs>
                    </Box>
                )
            } else {
                return (
                    <Box>
                        <SkeletonText noOfLines={10} />
                    </Box>
                )
            }
        }
    }
    

    const setMinBrDana = (val) => {
        const _brd = isNaN(val) ? -1 : Number(val);
        if (state !== undefined & _brd >= 0) {
            setState({ ...state, min: _brd });
        }
    }
    const setMaxBrDana = (val) => {
        const _brd = isNaN(val) ? -1 : Number(val);
        if (state !== undefined & _brd >= 0) {
            setState({ ...state, max: _brd });
        }
    }
    const TovDani = () => {

        if (state !== undefined) {
            return (
                <Box>
                    <FormLabel size={'xs'}>Minimalni broj dana</FormLabel>
                    <NumberInput focusBorderColor='grunt2.400' id="idTovDatMin" max={state.max} size="xs" value={state.min} onChange={setMinBrDana} variant={'filled'}><NumberInputField /></NumberInput>
                    <FormLabel size={'xs'}>Maksimalni broj dana</FormLabel>
                    <NumberInput focusBorderColor='grunt2.400' id="idTovDatMin" size="xs" value={state.max} onChange={setMaxBrDana} variant={'filled'}><NumberInputField /></NumberInput>
                </Box>
            )
        }


    }

    const TovDatumi = () => {

        if (state !== undefined) {
            return (
                <Box>
                    <FormLabel size={'xs'}>Od datuma</FormLabel>
                    <Input focusBorderColor='grunt2.400' mb={'1rem'} id="idTovDatOd" size="xs" type="date" variant={'filled'} display={'block'} value={state.datod} onChange={setTovDatumValue} />
                    <FormLabel size={'xs'}>Do datuma</FormLabel>
                    <Input focusBorderColor='grunt2.400' id="idTovDatDo" size="xs" type="date" variant={'filled'} display={'block'} value={state.datdo} onChange={setTovDatumValue} />
                </Box>
            )
        }
    }

    const RodDatumi = () => {

        if (state !== undefined) {
            return (
                <Box>
                    <FormLabel size={'xs'}>Od datuma</FormLabel>
                    <Input focusBorderColor='grunt2.400' mb={'1rem'} id="idRodDatOd" size="xs" type="date" variant={'filled'} display={'block'} value={state.datod} onChange={setRodDatumValue} />
                    <FormLabel size={'xs'}>Do datuma</FormLabel>
                    <Input focusBorderColor='grunt2.400' id="idROdDatDo" size="xs" type="date" variant={'filled'} display={'block'} value={state.datdo} onChange={setRodDatumValue} />
                </Box>
            )
        }
    }
    const setTovDatumValue = (event) => {
        const _val = event.target.value;
        if (event.target.id === "idTovDatOd") {
            setState({ ...state, datod: _val });
        } else {
            setState({ ...state, datdo: _val });
        }
    }
    const setRodDatumValue = (event) => {
        const _val = event.target.value;
        if (event.target.id === "idRodDatOd") {
            setState({ ...state, datod: _val });
        } else {
            setState({ ...state, datdo: _val });
        }
    }

    const SpolShow = () => {

        return (
            <Box mb={'1rem'}>
                <Box>
                    <Select placeholder='Odaberite spol' size={'sm'} value={state} onChange={(event) => setState(event.target.value)}>
                        <option value='m'>Muško</option>
                        <option value='f'>Žensko</option>
                    </Select>
                </Box>
            </Box>
        )

    }

    const BrzaPretragaSettingsShow = () => {

        return (
            <Box mb={'1rem'}>
                <SimpleGrid columns={2} spacing={30}>
                    <Box height='20px'>
                        <Text fontSize={'xs'} fontWeight={'semibold'}>Pretraga po:</Text>
                    </Box>
                    <Box height='20px'>

                    </Box>
                    <Box height='10px'>
                        <Text fontSize={'xs'} fontWeight={'medium'}>Životnom broju</Text>
                    </Box>
                    <Box height='10px'>
                        <Switch size={'sm'} value={quickFilterTypesState === "zivbr"} id="swZivbr" colorScheme="grunt2" isChecked={quickFilterTypesState === "zivbr"} onChange={SwitchValueChanged} />
                    </Box>
                    <Box height='10px'>
                        <Text fontSize={'xs'} fontWeight={'normal'}>RFID</Text>
                    </Box>
                    <Box height='10px'>
                        <Switch size={'sm'} value={quickFilterTypesState === "rfid"} id="swRfid" colorScheme="grunt2" isChecked={quickFilterTypesState === "rfid"} onChange={SwitchValueChanged} />
                    </Box>
                    <Box height='10px'>
                        <Text fontSize={'xs'} fontWeight={'normal'}>Oznaka na putnici</Text>
                    </Box>
                    <Box height='10px'>
                        <Switch size={'sm'} value={quickFilterTypesState === "oznput"} id="swOznput" colorScheme="grunt2" isChecked={quickFilterTypesState === "oznput"} onChange={SwitchValueChanged} />
                    </Box>
                </SimpleGrid>
            </Box>
        )

    }
    const onPasminaSelect = (sif) => {
        const _p = [...pasmine];
        _p.forEach((item) => item.selected = false);
        sif.forEach((passif) => {
            const _idx = _p.findIndex((item) => item.sifra === passif);
            if (_idx !== -1) {
                _p[_idx].selected = true;

            }
        })
        setPasmine(_p);

    }

    const showPasmine = () => {
        const _filteredpasmine = pasmine.filter((item) => item.selected === true).map((item) => item.sifra);
        if (pasmine.length > 0) {
            return (
                <Box>
                    <SmallMultiFilter data={pasmine} selectedid={_filteredpasmine} idfieldname="sifra" textfieldname="pasmina" onSelect={onPasminaSelect} />
                </Box>
            )
        } else {
            return (
                <Box>
                    <SkeletonText noOfLines={10} />
                </Box>
            )
        }

    }

    const SwitchValueChanged = (event) => {
        //const _s=[...quickFilterTypesState];
        const _s1 = event.target.id === "swZivbr" ? "zivbr" : event.target.id === "swRfid" ? "rfid" : "oznput";
        setQuickFilterTypesState(_s1);

    }

    const onLokacijeSelectChange = (odjeljci) => {
        setState(odjeljci);
    }

    const showControl = () => {
        if (registerfiltertype.sif === RegistarFilterTypes.Knjige.sif) {
            return (
                <>

                    <KnjigeSelect selectedKnjige={knjige} onKnjigeSelect={(k) => { setKnjige(k) }} />
                </>
            )
        } else {
            if (registerfiltertype.sif === RegistarFilterTypes.StanjeNaDan.sif) {
                return (
                    <Box>
                        <FormLabel>Datum</FormLabel>
                        <Input focusBorderColor='grunt2.400' id="idDatum" size="xs" type="date" variant={'filled'} display={'block'} value={state} onChange={setFilterValue} />
                    </Box>
                )
            } else if (registerfiltertype.sif === RegistarFilterTypes.DolasciTipPeriod.sif) {
                //return DolazakTipPeriod();
                return DolazakTipPeriodTabs();
            } else if (registerfiltertype.sif === RegistarFilterTypes.OdlasciTipPeriod.sif) {
                //return OdlazakTipPeriod();
                return OdlazakTipPeriodTabs();
            } else if (registerfiltertype.sif === RegistarFilterTypes.Lokacije.sif) {
                return (<LokacijeSelect data={lokacije} onChange={onLokacijeSelectChange} />)
            } else if (registerfiltertype.sif === RegistarFilterTypes.TovDani.sif) {
                return TovDani();
            } else if (registerfiltertype.sif === RegistarFilterTypes.TovDatumi.sif) {
                return TovDatumi();
            } else if (registerfiltertype.sif === RegistarFilterTypes.RodDatumi.sif) {
                return RodDatumi();
            } else if (registerfiltertype.sif === RegistarFilterTypes.BrzaPretraga.sif) {
                return BrzaPretragaSettingsShow();
            } else if (registerfiltertype.sif === RegistarFilterTypes.Posjednici.sif) {
                /*return (
                    <Box>
                        <OsobaSelect onSelect={(osoba)=>setState(osoba.id)} naslov={''} subjekttipid="os" posjednicinaknjizi={true} showHeader={false} showSearch={false}/>
                    </Box>
                )*/
                return (<PosjednikKnjigaSelect selectedPosjednici={selectedPosjednici} onPosjednikSelect={(x) => { setSelectedPosjednici(x) }} />)
            }
            else if (registerfiltertype.sif === RegistarFilterTypes.Spol.sif) {
                return SpolShow();
            } else if (registerfiltertype.sif === RegistarFilterTypes.Pasmine.sif) {
                return showPasmine();
            }

        }


    }



    return (
        <>
            {showControl()}
            <Box display={'flex'} flexDir={'row'} mt={'2rem'}>
                <Button rightIcon={<MdFilterAlt />} colorScheme={'grunt2'} size={'xs'} onClick={filterData} >{registerfiltertype.sif === RegistarFilterTypes.BrzaPretraga.sif ? 'Primijeni' : 'Filtriraj'}</Button>
                <Button colorScheme={'grunt2'} ml={'1rem'} rightIcon={<MdCancel />} variant={'outline'} size={'xs'} onClick={onClose}>Odustani</Button>
                <Button colorScheme={'red'} ml={'1rem'} mr={'1rem'} rightIcon={<MdClear />} variant={'outline'} size={'xs'} onClick={onClear}>Ukloni filter</Button>
                <Text color={'red'} size={'xs'}>{err}</Text>
            </Box>
        </>)

}

